import React, { useEffect, useRef } from "react";
import { withRouter } from "react-router";
import { useAnalyticsProvider } from "../index";

const OSSRouteTracker = ({ location }) => {
  const setTrackerData = useAnalyticsProvider();
  const currentUrl = useRef("");

  useEffect(() => {
    if (currentUrl.current !== location.pathname) {
      currentUrl.current = location.pathname;
      setTrackerData({
        method: "pageview",
        url: location.pathname
      });
    }
  }, [location.pathname, setTrackerData]);

  return <React.Fragment />;
};

export default withRouter(OSSRouteTracker);
